import React from "react";
import "../Leadership/LeaderBuildWithUs.css";
import bgGradient from "../../Assets/rock-bg.png";
import handsImage from "../../Assets/leadership/white-rock-with-hands.png";
import { useNavigate } from "react-router-dom";

const BuildersBuildWithUs = () => {
  const navigate=useNavigate();
  return (
    <section className="build-with-us">
      {/* <img src={bgGradient} alt="Background" className="build-bg" /> */}

      <div className="build-content-wrapper">
        <h2 className="build-heading">Build With Us</h2>

        <div className="build-box">
          <div className="text-content">
            <h3> Let’s Bring Your Dream to Life</h3>
            <p>
              Let’s start a conversation about turning your project into a landmark for communities. For you. For tomorrow.
            </p>
            <button className="build-partner-btn" onButtonClick={() => navigate("/Contact")}>Partner With Our Group</button>
          </div>

          <div className="image-content">
            <img src={handsImage} alt="Hands Raised" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BuildersBuildWithUs;
